<div class="h-full flex flex-col">
    <div class="tabs relative w-full max-w-full overflow-hidden flex flex-row items-center justify-between">
        <div
            #tabsContainer
            class="flex flex-row overflow-x-auto scrollbar-hidden scroll-smooth max-w-full w-full"
            (scroll)="checkScrollButtons()">
            @for (tab of tabs(); track $index) {
                <div
                    class="shrink-0 rounded-t-lg px-10 py-3.5 transition duration-100 ease-in-out"
                    [class]="tabClasses()[$index]"
                    [class.max-w-52]="isTruncateAllowed()"
                    [matTooltip]="
                        tab.disabled
                            ? (tab.disabledTooltipKey | transloco)
                            : translateTabs()
                              ? (tab.name | transloco)
                              : tab.name
                    "
                    [matTooltipDisabled]="tab.disabled ? !tab.disabledTooltipKey : !isTruncated($index)"
                    [matTooltipShowDelay]="500"
                    (click)="onTabClick($index)">
                    <div class="tab-label-wrapper flex items-center gap-2">
                        <p
                            #tabElement
                            class="!m-0 text-base font-normal text-nowrap transition duration-200 ease-in-out text-ellipsis overflow-hidden"
                            [class.opacity-50]="tab.disabled && highlightedTabName() !== tab.name"
                            [class.text-secondary]="highlightedTabName() === tab.name">
                            {{ translateTabs() ? (tab.name | transloco) : tab.name }}
                        </p>

                        @if (tabsBadge()?.[$index]) {
                            <span class="tab-edit-badge"></span>
                        }

                        @if (tab.canCreate) {
                            <app-create-entity-button
                                [disabled]="!!tab.createDisabled || !!tab.disabled"
                                [stopPropagation]="true"
                                [tooltipKey]="tab.createTooltipKey"
                                (clicked)="onCreateClick($index)" />
                        }
                    </div>
                </div>
            }
        </div>

        @if (canAddTab()) {
            <app-button
                class="pointer-events-auto"
                iconSize="xl"
                [icon]="['fas', 'plus']"
                [type]="ButtonType.SECONDARY"
                (click)="createTab.emit()" />
        }

        @if (showScrollLeft() || showScrollRight()) {
            <div class="flex flex-row z-10 h-full m-auto mr-8">
                <button
                    [class.active]="showScrollLeft()"
                    (click)="scrollLeft()">
                    <fa-icon
                        size="xl"
                        [icon]="['fas', 'chevron-left']" />
                </button>
                <button
                    [class.active]="showScrollRight()"
                    (click)="scrollRight()">
                    <fa-icon
                        size="xl"
                        [icon]="['fas', 'chevron-right']" />
                </button>
            </div>
        }
    </div>

    <div [class]="isSimpleTabStyle() ? '' : `${activeTabColor()} p-2.5 rounded-b flex-1 flex flex-col min-h-0 grow`">
        @for (tab of tabs(); track $index) {
            @if (currentTabIndex() === $index && !tab.disabled) {
                <div class="tab-content flex-1 flex flex-col min-h-0">
                    <ng-container *ngTemplateOutlet="tabContents()[$index]?.templateRef" />
                </div>
            }
        }
    </div>
</div>
